import { onBeforeUnmount } from "vue";

/**
 * Keep the screen on while the slideshow plays or the film is made (a phone that locks
 * would stop both). Released on unmount; `hold` again after the page was hidden.
 */
export function useWakeLock() {
  let lock: WakeLockSentinel | null = null;
  /** Counts releases, so a request still pending when released lets go once it arrives. */
  let generation = 0;

  async function hold() {
    const asked = generation;
    try {
      const got = (await navigator.wakeLock?.request("screen")) ?? null;
      if (asked === generation) {
        // A second hold while one is kept: let the older go, or it would never be released.
        lock?.release().catch(() => undefined);
        lock = got;
      } else {
        got?.release().catch(() => undefined);
      }
    } catch {
      // No wake lock: the screen may dim, nothing else changes.
    }
  }

  function release() {
    generation += 1;
    lock?.release().catch(() => undefined);
    lock = null;
  }

  onBeforeUnmount(release);
  return { hold, release };
}
